import { html } from "lit";

export default html`<uxt-icon class="ms-1" icon="new-tab"></uxt-icon>`;
